// P14 — Event bus mínimo pra forçar refresh do QuotaIndicator depois de
// ações que mudam tokens (ex.: envio de mensagem). Substituto leve de WS
// — outras telas chamam `emitQuotaRefresh()` e o indicator escuta.

export const QUOTA_REFRESH_EVENT = 'quota:refresh';

export function emitQuotaRefresh(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(QUOTA_REFRESH_EVENT));
  }
}
